module.exports = __webpack_public_path__ + "static/img/a.599d38b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/a.png
// module id = 71w+
// module chunks = 12